export enum ProductSourceTypeModel {
  CONTRACT = 'Contract',
  VCC = 'VccCategory',
}
